module.exports = __webpack_public_path__ + "static/media/mongo.73362d69.png";